export default {
    namespaced: true,
    state: {
        games:[]
    },
    getters: {
        games(state) {
            return state.games;
        }
    },
    mutations: {
        setGames(state, data) {
            state.games = data;            
        }
    },
    actions: {
        loadGames({ commit }, data) {
            this.getters.socket.emit("get_arcade_list", (data) => {
                commit('setGames', data);
            });
            
        }
    }
};